import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  BlueStatusMessage,
  RedStatusMessage,
} from '../../common/components/styledComponents';

interface ReceiptMessageProps {
  receiptUrl: string | undefined;
}
export const ReceiptMessage = ({ receiptUrl }: ReceiptMessageProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.payments.table',
  });

  const onClickReceipt = useCallback(() => {
    if (receiptUrl) {
      window.open(receiptUrl, '_blank', 'noopener,noreferrer');
    }
  }, [receiptUrl]);

  return receiptUrl ? (
    <BlueStatusMessage onClick={onClickReceipt}>{`${t(
      'receipt',
    )}`}</BlueStatusMessage>
  ) : (
    <></>
  );
};
